function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as Utility from "../commons/Utility";
import * as Api from "../ajax/SessionApi";
import IntlMessage from '../commons/Intl';
import { Action, Errors, SceneFilters, SessionScenes } from '../commons/IntlMessages';
import { ApiResultCodes } from "../enum/ApiResultCodes";
import { SceneTypes } from "../enum/SceneTypes";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // 会議シーン選択モーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 表示
   */

  Mode[Mode["Show"] = 1] = "Show";
})(Mode || (Mode = {}));
/**
 * 会議シーン選択モーダルコンポーネント
 */


var SessionSceneModalComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(SessionSceneModalComponent, _React$Component);

  var _super = _createSuper(SessionSceneModalComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function SessionSceneModalComponent(props) {
    var _this;

    _classCallCheck(this, SessionSceneModalComponent);

    _this = _super.call(this, props);

    switch (props.mode) {
      case Mode.Show:
        _this.state = {
          Modal: null,
          SceneModelName: _this.props.sceneModelName,
          SceneImageName: _this.props.sceneImageName,
          SelectedSceneFilter: 0,
          SelectedScene: null,
          SceneList: [],
          RequestList: [],
          IsProcessing: false
        };
        break;

      default:
        throw Error;
    }

    Api.GetSceneList(Utility.NullNumberToBlank(_this.props.baseSessionId), _this.props.targetFolderName, function (data) {
      var sceneList = data.SceneList;
      var selectedScene = sceneList.find(function (s) {
        return s.SceneImageName == _this.state.SceneImageName;
      });

      _this.setState({
        SelectedScene: selectedScene ? selectedScene : null,
        SceneList: sceneList
      }, function () {
        _this.updateSceneList();
      });
    });
    return _this;
  }
  /**
   * 会議シーン一覧更新
   */


  _createClass(SessionSceneModalComponent, [{
    key: "updateSceneList",
    value: function updateSceneList() {
      var _this2 = this;

      var requests = this.state.RequestList;

      for (var i = 0; i < requests.length; i++) {
        requests[i].abort();
      }

      this.setState({
        RequestList: []
      });
      var sceneList = this.state.SceneList.filter(function (s) {
        return _this2.checkSceneFilter(s.SceneType);
      });

      for (var i = 0; i < sceneList.length; i++) {
        var loading = $(".loadingImage-" + i.toString());
        var scene = $(".sceneImage-" + i.toString());
        var scene360 = $(".scene360-" + i.toString());
        var sceneImage = sceneList[i];

        if (loading && scene && scene360) {
          loading.removeClass("loading-hidden");
          scene.addClass("loading-hidden");
          scene360.addClass("hidden");

          if (sceneImage) {
            var xhr = Api.GetSceneThubnail(Utility.NullNumberToBlank(this.props.baseSessionId), this.props.targetFolderName, sceneImage.SceneImageName, 0, i, 0, sceneImage.SceneType, function (x, y, type, file) {
              var loading = $(".loadingImage-" + x.toString());
              var capture = $(".sceneImage-" + x.toString());
              var scene360 = $(".scene360-" + x.toString());
              capture.attr('src', URL.createObjectURL(file));
              loading.addClass("loading-hidden");
              capture.removeClass("loading-hidden");

              if (type == SceneTypes._360DegreeImage) {
                scene360.removeClass("hidden");
              }
            });
            var requests = this.state.RequestList;
            requests.push(xhr);
            this.setState({
              RequestList: requests
            });
          } else {
            scene.attr('src', "/assets/img/noimage.png");
            loading.addClass("loading-hidden");
            scene.removeClass("loading-hidden");
          }
        }
      }
    }
    /**
     * シーン選択時の処理を行います。
     */

  }, {
    key: "onSelect",
    value: function onSelect(model) {
      this.setState({
        SelectedScene: model
      });
    }
    /**
     * 「決定」ボタン押下時の処理を行います。
     */

  }, {
    key: "onDecide",
    value: function onDecide() {
      if (this.state.Modal == null) {
        throw Error();
      }

      if (this.state.SelectedScene == null) {
        return;
      }

      this.props.onDecide(this.state.SelectedScene);
      this.state.Modal.modal('hide');
    }
    /**
     * 「戻る」ボタン押下時の処理を行います。
     */

  }, {
    key: "onBack",
    value: function onBack() {
      if (this.state.Modal == null) {
        throw Error();
      }

      this.props.onBack();
      this.state.Modal.modal('hide');
    }
    /**
     * 選択フィルターを変更します。
     *
     * @param e イベント
     */

  }, {
    key: "onChangeSceneFilter",
    value: function onChangeSceneFilter(e) {
      var _this3 = this;

      this.setState({
        SelectedSceneFilter: Number(e.target.value)
      }, function () {
        _this3.updateSceneList();
      });
    }
    /**
     * 選択フィルターを適用します。
     *
     * @param sceneType シーン種別
     */

  }, {
    key: "checkSceneFilter",
    value: function checkSceneFilter(sceneType) {
      switch (this.state.SelectedSceneFilter) {
        case 1:
          return sceneType == SceneTypes.Room;

        case 2:
          return sceneType == SceneTypes._360DegreeImage;

        default:
          return true;
      }
    }
    /**
     * シーンイメージファイルをアップロードします。
     */

  }, {
    key: "uploadSceneImageFile",
    value: function uploadSceneImageFile() {
      this.$file.click();
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;

      var modal = $('#SessionSceneDialogModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      });
      var list = document.querySelectorAll(".modal-backdrop");

      for (var i = 0; i < list.length; i++) {
        if (!list[i].classList.contains("nested")) {
          list[i].classList.add("nested");
        }
      } // ポップアップが完全に非表示になった時のイベント。


      modal.on("hidden.bs.modal", function (e) {
        var list = document.querySelectorAll(".modal-backdrop");

        for (var i = 0; i < list.length; i++) {
          if (list[i].classList.contains("nested")) {
            list[i].classList.remove("nested");
          }
        }

        _this4.props.onHidden();
      });
      this.$file = $("#UploadSceneImageFile");
      this.$file.fileupload({
        add: function add(_e, data) {
          this.isSubmit = true;
          data.submit();
        },
        url: "SessionApi/UploadSceneImageFile",
        type: "POST",
        replaceFileInput: false,
        singleFileUploads: true,
        timeout: 10800000,
        start: function start(_e) {
          if (_this4.state.IsProcessing) return;
          setTimeout(function () {
            $("#overlay").fadeIn();
          });

          _this4.setState({
            IsProcessing: true
          });
        },
        done: function done(_e, data) {
          var model = data.result;

          if (model.ResultCode == ApiResultCodes.UnsupportedDataType || model.ResultCode == ApiResultCodes.LengthError) {
            alert(model.ResultMessage);
          }

          setTimeout(function () {
            $("#overlay").fadeOut(300);
          }, 500);

          _this4.setState({
            IsProcessing: false,
            SceneModelName: "",
            SceneImageName: model.ResultCode == ApiResultCodes.Success ? model.SceneImageFileName : _this4.state.SelectedScene != null && _this4.state.SelectedScene.SceneImageName != null ? _this4.state.SelectedScene.SceneImageName : _this4.state.SceneImageName
          }, function () {
            Api.GetSceneList(Utility.NullNumberToBlank(_this4.props.baseSessionId), _this4.props.targetFolderName, function (data) {
              var sceneList = data.SceneList;
              var selectedScene = sceneList.find(function (s) {
                return s.SceneImageName == _this4.state.SceneImageName;
              });

              _this4.setState({
                SelectedScene: selectedScene ? selectedScene : null,
                SceneList: sceneList
              }, function () {
                _this4.updateSceneList();
              });
            });
          });
        },
        fail: function fail(_e, data) {
          alert(intl.format(Errors.FileUploadFailed));
          setTimeout(function () {
            $("#overlay").fadeOut(300);
          }, 500);

          _this4.setState({
            IsProcessing: false,
            SceneModelName: "",
            SceneImageName: _this4.state.SelectedScene != null && _this4.state.SelectedScene.SceneImageName != null ? _this4.state.SelectedScene.SceneImageName : _this4.state.SceneImageName
          }, function () {
            Api.GetSceneList(Utility.NullNumberToBlank(_this4.props.baseSessionId), _this4.props.targetFolderName, function (data) {
              var sceneList = data.SceneList;
              var selectedScene = sceneList.find(function (s) {
                return s.SceneImageName == _this4.state.SceneImageName;
              });

              _this4.setState({
                SelectedScene: selectedScene ? selectedScene : null,
                SceneList: sceneList
              }, function () {
                _this4.updateSceneList();
              });
            });
          });
        }
      });
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "SessionSceneDialogModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        id: "TargetFolderName",
        name: "TargetFolderName",
        value: this.props.targetFolderName
      }), /*#__PURE__*/React.createElement("input", {
        type: "File",
        name: "UploadSceneImageFile",
        id: "UploadSceneImageFile",
        multiple: false,
        accept: ".exr,.hdr,.jpg,.jpeg,.png"
      }), /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "40",
        src: "/assets/img/Icon_SceneSelect.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(SessionScenes.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "sceneHeader"
      }, /*#__PURE__*/React.createElement("div", {
        className: "leftHeader"
      }, /*#__PURE__*/React.createElement("div", {
        className: "radio"
      }, /*#__PURE__*/React.createElement("input", {
        id: "All",
        name: "All",
        type: "radio",
        value: "0",
        checked: this.state.SelectedSceneFilter == 0,
        onChange: this.onChangeSceneFilter.bind(this)
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: "All"
      }, intl.format(SceneFilters.All))), /*#__PURE__*/React.createElement("div", {
        className: "radio"
      }, /*#__PURE__*/React.createElement("input", {
        id: "Room",
        name: "Room",
        type: "radio",
        value: "1",
        checked: this.state.SelectedSceneFilter == 1,
        onChange: this.onChangeSceneFilter.bind(this)
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: "Room"
      }, intl.format(SceneFilters.Room))), /*#__PURE__*/React.createElement("div", {
        className: "radio"
      }, /*#__PURE__*/React.createElement("input", {
        id: "360DegreeImage",
        name: "360DegreeImage",
        type: "radio",
        value: "2",
        checked: this.state.SelectedSceneFilter == 2,
        onChange: this.onChangeSceneFilter.bind(this)
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: "360DegreeImage"
      }, intl.format(SceneFilters._360DegreeImage))))), /*#__PURE__*/React.createElement("div", {
        id: "ThumbnailScenes",
        className: "col-12"
      }, this.state.SelectedSceneFilter != 1 && /*#__PURE__*/React.createElement("div", {
        className: "col-1-5",
        key: intl.format(SessionScenes.UploadTitle)
      }, /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.uploadSceneImageFile.bind(this),
        key: intl.format(SessionScenes.UploadTitle),
        tabIndex: -1,
        title: intl.format(SessionScenes.UploadTitle)
      }, /*#__PURE__*/React.createElement("div", {
        className: "uploadImageFrame"
      }, /*#__PURE__*/React.createElement("img", {
        className: "uploadImageIcon",
        src: "/assets/img/upload_icon.svg"
      }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("label", {
        className: "uploadImageTitle"
      }, intl.format(SessionScenes.UploadTitle)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("label", {
        className: "uploadImageDescription"
      }, intl.format(SessionScenes.UploadDescription))))), this.state.SceneList && this.state.SceneList.filter(function (s) {
        return _this5.checkSceneFilter(s.SceneType);
      }).map(function (x, _i) {
        return /*#__PURE__*/React.createElement("div", {
          className: "col-1-5 " + (_this5.state.SelectedScene != null && _this5.state.SelectedScene.SceneImageName == x.SceneImageName ? "selected" : ""),
          key: x.SceneImageName
        }, /*#__PURE__*/React.createElement("a", {
          className: "button",
          href: "#",
          onClick: _this5.onSelect.bind(_this5, x),
          key: x.SceneImageName,
          tabIndex: -1,
          title: "Scene" + x.SceneImageName
        }, /*#__PURE__*/React.createElement("div", {
          className: "sceneImageFrame"
        }, /*#__PURE__*/React.createElement("img", {
          className: "sceneImage loadingImage-" + _i.toString() + " loading-spinner",
          src: "/assets/img/Loading.svg"
        }), /*#__PURE__*/React.createElement("img", {
          className: "sceneImage sceneImage-" + _i.toString() + " loading-hidden",
          src: "/assets/img/noimage.png"
        }), /*#__PURE__*/React.createElement("img", {
          className: "scene360 scene360-" + _i.toString() + " hidden",
          src: "/assets/img/Icon_360Image.svg"
        })), /*#__PURE__*/React.createElement("label", {
          className: "display-label"
        }, x.SceneDisplayName)));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        key: "onBack",
        type: "button",
        className: "btn btn-default",
        onClick: this.onBack.bind(this),
        tabIndex: -1
      }, intl.format(Action.Back)), /*#__PURE__*/React.createElement("button", {
        key: "onDecide",
        type: "button",
        className: "btn btn-primary",
        onClick: this.onDecide.bind(this),
        tabIndex: -1
      }, intl.format(Action.Decide)), ","))));
    }
  }]);

  return SessionSceneModalComponent;
}(React.Component);

export { SessionSceneModalComponent as default };